import { render, staticRenderFns } from "./DashboardBlogFeed.vue?vue&type=template&id=c3decfc4&"
import script from "./DashboardBlogFeed.vue?vue&type=script&lang=ts&"
export * from "./DashboardBlogFeed.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardBlogFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports